const CONTRACT = 'quantity_percent_v2';
const money = cents => `$${(cents / 100).toFixed(2).replace('.00', '')}`;
const eligible = item => PawtyPayment.eligible(item);
const orderPricingLabel = ({ count, full, paid, balance, savings }) => `${count} artwork${count === 1 ? '' : 's'} · ${money(full)} full · ${money(paid)} today · ${money(balance)} after approval · save ${money(savings)}`;
let running = false;
let checkoutSyncing = false;
async function syncPricing() {
  if (running || window.PawtyCartMutation) return;
  running = true;
  try {
    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.json());
    const calculated = PawtyPayment.cartTotals(cart);
    const values = { count: String(calculated.count), full: calculated.valid ? money(calculated.full) : '—', paid: money(calculated.actualPaid), balance: calculated.valid ? money(calculated.balance) : '—', savings: calculated.valid ? money(calculated.savings) : '—', regular: money(calculated.count * 3900) };
    Object.entries(values).forEach(([key, value]) => document.querySelectorAll(`[data-unified-${key}]`).forEach((node) => { if (node.textContent !== value) node.textContent = value; }));
    document.querySelectorAll('[data-unified-count-label]').forEach((node) => { const label = `${calculated.count} artwork${calculated.count === 1 ? '' : 's'} × $39`; if (node.textContent !== label) node.textContent = label; });
    document.querySelectorAll('[data-pawty-payment-error]').forEach(node => { node.hidden = calculated.valid; });
    document.querySelectorAll('[name=checkout]').forEach(button => { if (!button.hasAttribute('aria-busy') && button.textContent.trim() !== 'Continue to checkout') button.textContent = 'Continue to checkout'; });
    document.querySelectorAll('[data-unified-discount], [data-unified-regular]').forEach((node) => node.toggleAttribute('hidden', calculated.count <= 1 || !calculated.valid));
    const desired = {
      '_Pricing contract': CONTRACT,
      '_Artwork count': values.count,
      '_Full order amount': values.full,
      '_Start paid today': values.paid,
      '_Balance after approval': values.balance,
      '_Artwork savings': values.savings,
    };
    if (!window.PawtyCartMutation && Object.entries(desired).some(([key, value]) => String(cart.attributes?.[key] || '') !== value)) {
      window.PawtyPricingRequest = fetch('/cart/update.js', { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: desired }) });
      await window.PawtyPricingRequest;
    }
  } catch (error) {
    console.warn('[pawty-unified-pricing]', error);
  } finally { running = false; }
}
async function syncCheckoutProperties(event) {
  const checkoutButton = event.target?.closest?.('[name="checkout"], [data-pawty-dynamic-checkout]');
  if (!checkoutButton || checkoutSyncing) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  checkoutSyncing = true;
  checkoutButton.disabled = true;
  checkoutButton.setAttribute('aria-busy', 'true');
  try {
    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.json());
    const eligibleItems = cart.items.filter(eligible);
    const calculated = PawtyPayment.cartTotals(cart);
    if (!calculated.valid) throw new Error('Your artwork discount is not ready. Please contact us before paying; no payment has been taken.');
    const label = orderPricingLabel(calculated);
    for (const item of eligibleItems) {
      const properties = { ...(item.properties || {}), '_Pricing contract': CONTRACT, 'Order pricing': label, 'Payment': PawtyPayment.mode(item) === 'full' ? 'Paid in full — priority production; no remaining balance' : 'Start payment — balance after proof approval' };
      delete properties['_Paid Today'];
      delete properties['Paid Today'];
      if (properties['Portrait type']) {
        properties['_Portrait type'] = properties['Portrait type'];
        delete properties['Portrait type'];
      }
      const photoCount = Object.entries(properties).filter(([key, value]) => key.includes('Reference photo') && value).length;
      properties['Your photos'] = photoCount ? `${photoCount} reference photo${photoCount === 1 ? '' : 's'} saved for this portrait` : 'Send after checkout';
      const note = properties['_Creative notes'] || properties['Creative notes'];
      if (note) properties['Your note'] = note;
      else delete properties['Your note'];
      if (JSON.stringify(properties) === JSON.stringify(item.properties)) continue;
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: item.quantity, properties }),
      });
      if (!response.ok) throw new Error(`Checkout pricing sync failed: ${response.status}`);
    }
    window.location.assign('/checkout');
  } catch (error) {
    console.warn('[pawty-unified-checkout]', error);
    document.querySelectorAll('[data-pawty-payment-error]').forEach(node => { node.hidden = false; node.textContent = error.message; });
    checkoutButton.disabled = false;
    checkoutButton.removeAttribute('aria-busy');
    checkoutSyncing = false;
  }
}
syncPricing();
document.addEventListener('cart:update', syncPricing);
document.addEventListener('click', syncCheckoutProperties, true);
new MutationObserver(() => window.requestAnimationFrame(syncPricing)).observe(document.documentElement, { childList: true, subtree: true });


window.addEventListener('pageshow', () => {
  checkoutSyncing = false;
  document.querySelectorAll('[name="checkout"][aria-busy="true"], [data-pawty-dynamic-checkout][aria-busy="true"]').forEach((button) => {
    button.disabled = false;
    button.removeAttribute('aria-busy');
  });
  syncPricing();
});
